module.exports = __webpack_public_path__ + "static/media/close.759e314a.svg";